import React from "react";
import HeadTittle from "../../../../../../components/HeadTittle";
import ButtonAction from "../../../../../../components/buttons/ButtonAction";
import { EditIcon } from "../../../../../../components/buttons/IconButtons";
import { permissionObj } from "../../../../../../Helpers/permission";
import StepperTabs from "../../../../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../../../../components/StepperTabs/StepTab";
import { STEPS_UPDATE_SHIFT_ACCESS } from "./Model/Models";
import { EditShiftAccessApp } from "./Functionality/EditShiftAccessApp";
import SectionAccessDevices from "./SubComponents/Steps/SectionAccessDevices";
import SectionAccessDepartments from "./SubComponents/Steps/SectionAccessDepartments";
import SectionCustomAccess from "./SubComponents/Steps/SectionCustomAccess";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Update shift access flow. Shows the three sections; a single header action
 * resubmits the whole shift body.
 */
const EditShiftAccess = () => {

    const {
        id,
        DEV,
        permission,
        emptyFields,
        disabled,
        item,
        handleChange,

        devices, setDevices,
        selectDeleteDevices, setSelectDeleteDevices,
        searchElement,
        setSearchElement,
        departments, setDepartments,
        selectDeleteDepartments, setSelectDeleteDepartments,
        modified, setModified,
        user, setUser,
        selectDeleteUser, setSelectDeleteUser,

        steps,
        activeStep, setActiveStep,
        handleStepChange,
        handleAddEdit,
        handleOnBack,
    } = EditShiftAccessApp();

    return (
        <>
            <HeadTittle onBack={handleOnBack} name={disabled ? 'details' : 'update'}>
                {(DEV || permission?.includes(permissionObj?.WEB_ATTENDANCE_SHIFT_UPDATE)) &&
                    <div className='col-12 d-flex justify-content-end gap-2 flex-wrap mb-4'>
                        <ButtonAction
                            id={'btn_esa_update_data'}
                            name='update'
                            className='btn-icon-edit'
                            Icon={EditIcon}
                            onClick={() => handleAddEdit()}
                        />
                    </div>
                }
            </HeadTittle>

            <StepperTabs
                id={id}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={STEPS_UPDATE_SHIFT_ACCESS.ACCESS_DEVICE.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_UPDATE_SHIFT_ACCESS.ACCESS_DEVICE.INDEX && (
                        <SectionAccessDevices
                            id={id}
                            item={item}
                            handleChange={handleChange}
                            emptyFields={emptyFields}
                            disabled={disabled}
                            devices={devices}
                            setDevices={setDevices}
                            selectDeleteDevices={selectDeleteDevices}
                            setSelectDeleteDevices={setSelectDeleteDevices}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            modified={modified}
                            setModified={setModified}
                            mainContainerClass={'border-full-shades-200'}
                        />
                    )}
                </StepTab>

                <StepTab index={STEPS_UPDATE_SHIFT_ACCESS.ACCESS_DEPARTMENTS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_UPDATE_SHIFT_ACCESS.ACCESS_DEPARTMENTS.INDEX && (
                        <SectionAccessDepartments
                            id={id}
                            departments={departments}
                            setDepartments={setDepartments}
                            selectDeleteDepartments={selectDeleteDepartments}
                            setSelectDeleteDepartments={setSelectDeleteDepartments}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            modified={modified}
                            setModified={setModified}
                            mainContainerClass={'border-full-shades-200 '}
                            disabled={disabled}
                        />
                    )}
                </StepTab>

                <StepTab index={STEPS_UPDATE_SHIFT_ACCESS.CUSTOM_ACCESS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_UPDATE_SHIFT_ACCESS.CUSTOM_ACCESS.INDEX && (
                        <SectionCustomAccess
                            id={id}
                            user={user}
                            setUser={setUser}
                            selectDeleteUser={selectDeleteUser}
                            setSelectDeleteUser={setSelectDeleteUser}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            modified={modified}
                            setModified={setModified}
                            mainContainerClass={'border-full-shades-200'}
                            disabled={disabled}
                        />
                    )}
                </StepTab>
            </StepperTabs>
        </>
    );
}

export default EditShiftAccess
